import { pick } from "../../util/object";
import { $httpAdmin, $httpAdminSync } from "../../api/http";
import { type AxiosPromise } from "../../modules/axios";
import { isNullOrUndef } from "../../util/data";

export interface NewsType {
  id: number;
  title: string;
}

export function apiNewsTypeGet(): AxiosPromise<NewsType[]> {
  return $httpAdmin.get('/title/mtxwtitleselect');
}

export async function apiNewsTypeAdd(params: Omit<NewsType, 'id'>): Promise<AxiosPromise> {
  await $httpAdminSync.post('/title/mtxwtitleadd', params);
  return $httpAdmin.post('/title/mtxwtitleadd', params);
}

export async function apiNewsTypeUpdate(params: Partial<NewsType>): Promise<AxiosPromise> {
  return $httpAdmin.patch('/title/mtxwtitleupdate', params);
}

export async function apiNewsTypeDelete(id: NewsType['id']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/title/mtxwtitledeletebyid/${id}`);
  return $httpAdmin.delete(`/title/mtxwtitledeletebyid/${id}`);
}

export interface News {
  id: number;
  belong: number;
  title: string;
  datetime: string;
  content: string;
}

export function apiNewsGet(params?: undefined | null): AxiosPromise<Omit<News, 'content'>[]>;
export function apiNewsGet(params: { id: News['id']; }): AxiosPromise<News>;
export function apiNewsGet(params?: { id: News['id']; } | null): AxiosPromise<Omit<News, 'content'>[] | News> {
  if (isNullOrUndef(params?.id)) return $httpAdmin.get('/title/mtxwselect');
  return $httpAdmin.post('/title/mtxwselectxq', undefined, { params });
}

export function apiNewsGetByBelong(params?: { belong: News['belong']; } | null): AxiosPromise<Omit<News, 'content'>[]> {
  if (isNullOrUndef(params?.belong)) return $httpAdmin.get('/title/mtxwselect');
  return $httpAdmin.post('/title/mtxwselectid', params);
}

export async function apiNewsAdd(params: Omit<News, 'id'>): Promise<AxiosPromise> {
  await $httpAdminSync.post('/title/mtxwadd', params);
  return $httpAdmin.post('/title/mtxwadd', params);
}

export function apiNewsUpdate(params: Partial<News>): AxiosPromise {
  return $httpAdmin.patch('/title/mtxwupdate', params);
}

export async function apiNewsDelete(id: News['id']): Promise<AxiosPromise> {
  await $httpAdminSync.delete(`/title/mtxwdeletebyid/${id}`);
  return $httpAdmin.delete(`/title/mtxwdeletebyid/${id}`);
}
